import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@championcare/ui/styles.css";
import "./styles.css";
import "@championcare/ui/portal-tokens.css";
import { AuthProvider } from "./auth";
import { ApiProvider } from "./api";
import { App } from "./App";
import { initObservability } from "./observability";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

void initObservability(); // Sentry (PHI-scrubbed, PII off) — no-op without a DSN

createRoot(root).render(
  <StrictMode>
    <AuthProvider>
      <ApiProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApiProvider>
    </AuthProvider>
  </StrictMode>,
);
